export default {
  getAutomations($state) {
    return $state.automations;
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
};
